import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AdvertisingService} from '../../../domain/advertising/service/advertising-service';
import {SafeSubscriberDirective} from '../../../application/app-context/safe-subscriber.directive';
import {AdvertisingDialogComponent} from './advertising/advertising-dialog.component';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent extends SafeSubscriberDirective implements OnInit {

  static readonly HOME_URL = 'home';
  static readonly COOKIE_MONITORING = 'fa-disable-advertising';

  constructor(public dialog: MatDialog,
              private readonly cookieService: CookieService,
              private advertisingService: AdvertisingService) {
    super();
  }

  public ngOnInit(): void {
    // Handle monitoring check
    if (this.cookieService.check(HomeComponent.COOKIE_MONITORING)) {
      return;
    }

    this.subs.push(this.advertisingService.next().subscribe(advertising => {
      if (advertising) {
        this.dialog.open(AdvertisingDialogComponent, {
          width: '600px',
          height: '500px',
          maxWidth: undefined,
          data: {
            advertising
          },
          panelClass: 'radius-mat-dialog'
        });
      }
    }));


  }
}
